import type { FieldCondition, FieldValues } from '@aviv-estimation-funnel/data-validation/types';
import { IRelatedFieldToUpdate } from '@mfe-types/field';

export const shouldBeDisplayed = (
    fieldValues: FieldValues,
    displayedConditions: Array<FieldCondition> = [],
): boolean => {
    for (const shouldBeDisplayed of displayedConditions) {
        if (!shouldBeDisplayed(fieldValues)) {
            return false;
        }
    }
    return true;
};

export const shouldBeEnabled = (
    fieldValues: FieldValues,
    enabledConditions: Array<FieldCondition> = [],
): boolean => {
    for (const shouldBeEnabled of enabledConditions) {
        if (!shouldBeEnabled(fieldValues)) {
            return false;
        }
    }
    return true;
};

export const shouldUpdateRelatedField = (
    fieldValues: FieldValues,
    relatedFieldToUpdate: IRelatedFieldToUpdate,
    currentFieldName: string,
) => {
    if (relatedFieldToUpdate?.conditions) {
        for (const shouldUpdate of relatedFieldToUpdate.conditions) {
            if (!shouldUpdate(fieldValues, currentFieldName, relatedFieldToUpdate?.fieldName)) {
                return false;
            }
        }
    }
    return true;
};
